import { Features } from './features';
import { Team, AutodeskUserProfile } from './forge';
import { UserProject } from './project.types';
import { CompanySettings } from './settings';

export type AuthenticatedUser = AutodeskUserProfile & {
	// Legacy/Auth0-like fields kept for backward compatibility in tests or older code paths
	sub?: string;
	email?: string;
	name?: string;
};
export interface GetProjectsParams {
	initializing: boolean;
	queryParams?: {
		cursor?: string | null;
		limit?: number | null;
		searchText?: string | null;
		sortBy?: string | null;
		sortOrder?: 'asc' | 'desc' | null;
		sourceId?: string;
	};
}

export interface AuthenticationContext {
	isAuthenticated: boolean;
	isInitializing: boolean;
	user?: AuthenticatedUser;
	token?: string;
	defaultSite: string;
	defaultSiteName: string;
	defaultSiteProjectId: string;
	defaultTeamId: string;
	client?: object;
	teams: Team[];
	companies: {
		isInitialized: boolean;
		isFetching: boolean;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		error: any;
		list: CompanySettings[];
	};
	projects: {
		isInitialized: boolean;
		isFetching: boolean;
		isProjectByIdInitialized: boolean;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		error: any;
		cursor: string | null;
		list: UserProject[];
	};
	logout?(o?: unknown, client?: object): void;
}

export interface AuthenticationProviderOptions {
	forceLogin: boolean;
	redirectUri: string;
	authenticate: boolean;
	onRedirectCallback?(result: unknown): void;
}

export interface AuthenticationProviderProps {
	options: AuthenticationProviderOptions;
	children: React.ReactElement;
	appFeatureFlags?: Features;
	isLandingPage?: boolean;
	readonly hasSharedWorkers?: boolean;
}

export interface AuthenticationContextStoreState {
	authenticationContext: AuthenticationContext;
}

export enum AuthType {
	Forge = 'forge',
}
/**
 * authorizerTokenCookie works for both forge & auth0 flow
 * It is named as auth0.user.token as all the microApps are expecting the token in this legacy cookie name
 */
export const authorizerTokenCookie = 'auth0.user.token';
export const authorizerTokenCookieExpirationDate = 'auth0.user.token.expiry';
export const forgeIdTokenCookie = 'forge.id.token';
export const forgeRefreshTokenCookie = 'forge.refresh.token';
export const forgeAccessTokenExpiration = 'forge.expirationDate';
export const forgeRevalidationCookie = 'forge.revalidation';
export const teamIdCookie = 'teamId';
export const AUTHENTICATION_PROVIDER = 'authentication.provider';
export const FACILITY_WORKSPACE_COOKIE = 'facility.workspace.id';

export const mockDatesOffsetStorageKey = 'mockDatesOffset';

export enum AUTHENTICATION_URL_PARAMS {
	AUTODESK = '/forge/login',
	REGION_PICKER = '/region/picker',
}
